import { Card } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { ReactElement } from 'react';

interface AudienceInsight {
  id: string;
  position: { x: number; y: number };
  fact: string;
}

// Mock insights that would normally come from an API
const AUDIENCE_INSIGHTS: AudienceInsight[] = [
  {
    id: '1',
    position: { x: 20, y: 25 },
    fact: 'Prefers video content between 30-60 seconds',
  },
  {
    id: '2',
    position: { x: 80, y: 45 },
    fact: 'Most active between 6PM and 9PM',
  },
  {
    id: '3',
    position: { x: 30, y: 65 },
    fact: 'Engages more with educational content',
  },
  {
    id: '4',
    position: { x: 70, y: 85 },
    fact: 'Responds well to question-based hooks',
  },
];

export const AudienceDnaCard = (): ReactElement => {
  return (
    <Card className="p-5 h-max w-full">
      <div className="flex flex-col gap-2">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h2 className="text-lg font-semibold">Audience DNA</h2>
        </motion.div>

        <div className="relative aspect-video rounded-lg overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover">
            <source src="/dna-genome.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </Card>
  );
};
